module.exports = __webpack_public_path__ + "031a9d4653e17b291ae0e20a31edddf5.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/header_top.svg
 ** module id = 254
 ** module chunks = 0
 **/